"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function cyclicIncrementor() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
  var currentValue = start - 1;
  return {
    reset: function reset() {
      currentValue = start - 1;
    },
    next: function next() {
      if (currentValue === max) {
        this.reset();
      }

      currentValue++;
      return currentValue;
    }
  };
}

var _default = cyclicIncrementor;
exports.default = _default;